'use client'

import { StoryblokLink } from '@/components/shared/storyblok-link'
import { Button } from '@/components/ui/button'
import { CompanyLogosStoryblok } from '@/lib/types/component-types-sb'
import { storyblokEditable } from '@storyblok/react/rsc'
import { AnimatePresence, motion } from 'motion/react'
import Image from 'next/image'
import { useState } from 'react'

export function CompanyLogos({ blok }: { blok: CompanyLogosStoryblok }) {
  const cta = blok.link?.at(0)
  const [isHovered, setIsHovered] = useState(false)

  return (
    <section
      {...storyblokEditable(blok)}
      className="py-20"
    >
      <div
        className="page-container"
        onMouseLeave={() => setIsHovered(false)}
      >
        <h2 className="space-x-1 text-center text-lg font-medium lg:space-x-0">
          <span className="text-accent-foreground lg:block">{blok.titleLine1}</span>
          <span className="text-muted-foreground lg:block">{blok.titleLine2}</span>
        </h2>
        <div className="relative mx-auto max-w-4xl py-14">
          <div
            className="grid grid-cols-2 justify-items-center gap-y-10 lg:grid-cols-3"
            onMouseEnter={() => setIsHovered(true)}
          >
            {blok.logos?.map((logo) => (
              <Image
                key={logo.filename}
                unoptimized={logo.filename.includes('svg')}
                src={logo.filename}
                width={200}
                height={200}
                alt={logo.alt ?? ''}
                className="h-10 w-auto"
              />
            ))}
          </div>
          <AnimatePresence>
            {isHovered && (
              <motion.div
                className="bg-background/30 absolute top-0 left-0 z-20 flex h-full w-full items-center justify-center backdrop-blur-sm"
                initial={{
                  opacity: 0,
                }}
                animate={{
                  opacity: 1,
                }}
                exit={{
                  opacity: 0,
                }}
              >
                {cta && (
                  <Button asChild>
                    <StoryblokLink link={cta.target}>{cta.label}</StoryblokLink>
                  </Button>
                )}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </section>
  )
}
